import React, { lazy } from 'react';
import PrivateRoute from 'PrivateRoutes';
const Dialpad = lazy(()=> import(/* webpackChunkName: "Dialpad" */'./components/Dialpad'));

const routes = () => <PrivateRoute exact path="/dial-pad" component={Dialpad} />;

export default routes;



// WEBPACK FOOTER //
// src/dialpad/routes.js